import React, { useEffect, useState } from 'react';
import './style.sass';
import { Header } from 'pages/Header'
import { Footer } from 'pages/Footer';
import { useConsultaSaldoData } from 'hooks/useConsultaSaldoData';
import { ModalError } from 'components/Error/ErrorModal'
import { MenuCredito } from 'components/menuCredito';
import { CheckStatusCard } from 'components/Credito/CheckStatusCard';
import { NextCardButton } from 'components/Credito/NextCardButton'
import { RemoveCardSears } from 'components/Credito/RemoveCard'
import { PagarPlan } from 'components/Credito/ButtonPayCard'
import { Points } from 'components/Credito/Points'

import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'
import { useHistory } from 'react-router-dom'
import { dataLayerButtons } from 'functions/dataLayerFunction'
import { Error500 } from 'components/Error/Error500'


export default function ConsultarSaldoDesktop(props) {
    const {
        cardsService,
        setUdCard,
        setLoad,
        errorCode
    } = props
    const history = useHistory();

    // funciones para mostrar el modal
    const [showModal, SetShowModal] = useState(false);
    const showModalErrorCode = () => SetShowModal(true);
    const handleCloseErrorCode = () => SetShowModal(false);

    useEffect(()=>{
        if(errorCode <= 499){
            showModalErrorCode()
        }
    },[errorCode])

    const { dataSaldos, loading, upDateDataSaldos } = useConsultaSaldoData(cardsService)

    useEffect(()=>{
        setLoad(loading)
    },[loading])


    // redirecciona a movimientos
    const handleMovimientos = () => {
        dataLayerButtons({eventName: "credito_movimientos"})
        history.push(`${BASE_PATH}${SUB_DIRECTORY}movimientos-tarjeta`);
    };
    // redirecciona a estado de cuenta
    const handleEstadoDeCuenta = () => {
        history.push(`${BASE_PATH}${SUB_DIRECTORY}solicitar-estado-cuenta`);
    };
    // redirecciona a pago express
    const handlePagoExpressOtraTarjeta = () => {
        dataLayerButtons({eventName: "credito_pagoexpress"})
        history.push(`${BASE_PATH}${SUB_DIRECTORY}pago-express`);
    };
    // redirecciona a seccion mi tarjeta
    const handleMiTarjeta = () => {
       // history.push(`${BASE_PATH}${SUB_DIRECTORY}mi-tarjeta`);
    };
    // redirecciona a agregar tarjeta
    const handleAgregarTarjeta = () => {
        dataLayerButtons({eventName: "credito_agregartarjeta"})
        history.push(`${BASE_PATH}${SUB_DIRECTORY}agregar-tarjeta`);
    };

    const [corte, setCorte] = useState(false)
    useEffect(()=>{
        if(Number(dataSaldos?.saldoBtnActive) >= 1){
            setCorte(true)
        }
        else{
            setCorte(false)
        }
    },[dataSaldos])


    // funcion para actualizar los datos
    //const updateServide = () => upDateDataSaldos()

    return (
        <>
            <Header type="complete"/>
            <main>
                <section className="sectionPrincipal">
                    <MenuCredito />
                    {errorCode >= 500
                        ? <Error500 />
                        :
                            <div className="contenido">
                                <div className="tituloPage">
                                    <p>Mi Crédito</p>
                                </div>

                                <div className="sectionConsultaDesk">
                                    <div className="sectionInterna1">
                                        <div className="boxTarjetaDsk">
                                            <div className="imaTarjetaConsultaDesk">
                                                <div className="imgDesk" onClick={handleMiTarjeta}>
                                                    <div className="numeroTarjeta">
                                                        <span>{dataSaldos.numeroTarjeta}</span>
                                                    </div>
                                                    <div className="titular">
                                                        <span>{dataSaldos.nombreTitular && dataSaldos.nombreTitular.toLowerCase()}</span>
                                                    </div>
                                                </div>
                                                <NextCardButton setUdCard={setUdCard} />
                                            </div>
                                        </div>

                                        <CheckStatusCard  dataSaldos={dataSaldos}/>

                                        <div className="boxBtnAgregarDesk">
                                            <button onClick={handleAgregarTarjeta}>Agregar tarjeta</button>
                                            <RemoveCardSears
                                                dataSaldos={dataSaldos}
                                                setUdCard={setUdCard}
                                            />
                                        </div>
                                    </div>

                                    <div className="sectionInterna2">
                                        <div className="boxSaldoMovimientosDesk">
                                            <div className="boxSaldoDesk">
                                                <div className="saldo">
                                                    <p className="titulo">Saldo actual</p>
                                                    <p className="monto">{dataSaldos.montoNuevoCorte}</p>
                                                </div>
                                                <div className="disponible">
                                                    <p className="titulo">Disponible para compras</p>
                                                    <p className="monto">{dataSaldos.saldoDisponible}</p>
                                                </div>
                                            </div>
                                            <div className="boxMovidesk">
                                                <p onClick={handleMovimientos}>Movimientos</p>
                                            </div>
                                        </div>

                                        <div className="boxEstadoCdesk">
                                            <p onClick={handleEstadoDeCuenta}>Estado de cuenta</p>
                                        </div>

                                        <div className="boxPagoEdesk">
                                            <p onClick={handlePagoExpressOtraTarjeta}>Pago express de otra tarjeta</p>
                                        </div>
                                    </div>

                                    <div className="sectionInterna3">
                                        <div className="boxSaldoDesk">
                                            <ul className="ulSaldo">
                                                <li>
                                                    <p className="pl">Mensualidad total:</p>
                                                    <p className="pr">{dataSaldos.montoMensualidad}</p>
                                                </li>
                                                <li>
                                                    <p className="pl">Mínimo a pagar:</p>
                                                    <p className="pr">{dataSaldos.montoMinimo}</p>
                                                </li>
                                                <li>
                                                    <p className="pl">Saldo nuevo al corte: </p>
                                                    <p className="pr">{dataSaldos.montoNuevoCorte}</p>
                                                </li>
                                                <li>
                                                    <p className="pl">Pago para no generar intereses: </p>
                                                    <p className="pr">{dataSaldos.montoPagoNoGenerarIntereses}</p>
                                                </li>
                                                <li>
                                                    {corte
                                                        ?
                                                            <>
                                                                <p className="pl">Fecha límite de pago:</p>
                                                            </>
                                                        :
                                                            <>
                                                                <p className="pl">Fecha del próximo corte:</p>
                                                            </>
                                                    }
                                                    <p className="pr">{dataSaldos.fechaLimite}</p>
                                                </li>
                                                <li>
                                                    <p className="pl">Límite de crédito:</p>
                                                    <p className="pr">{dataSaldos.montoLimiteCredito}</p>
                                                </li>
                                            </ul>
                                        </div>

                                        <PagarPlan cardending={dataSaldos.cardending} saldoPay={dataSaldos.saldoBtnActive}  />
                                        <Points cardsService={cardsService} />
                                        
                                    </div>
                                </div>
                            </div>
                    }
                    {showModal &&
                        <ModalError errorCode={errorCode} handleClose={handleCloseErrorCode} />
                    }
                </section>
            </main>
            <Footer type="complete"/>
        </>
    )
}